import { imageUrl } from 'utils/filestack';

export function getCmsAmpHeroBlockImageUrl(
  handle: string,
  mimetype: string | undefined
) {
  return imageUrl({
    handle,
    mimetype,
    transform: `resize=width:2096,fit:max/quality=value:70`,
  });
}
